import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { Route } from 'react-router-dom';

const SecureRoute = ({
  component: Component,
  scopes,
  totalSecureRoutes,
  history,
  isAuthenticated,
  loginWithRedirect,
  ...rest
}) => {
  const isValidUrl = useMemo(() => checkUrl(), []);
  function checkUrl() {
    const pathname = history.location.pathname;
    const url = pathname === '/' ? pathname : getUrl(pathname);
    if (url === '/') {
      return true;
    }
    return (
      totalSecureRoutes.findIndex(route => route.path.toLowerCase() === url.toLowerCase()) > -1
    );
  }

  function getUrl(pathname) {
    const pathnameLength = pathname.length;
    const lastChar = pathname.charAt(pathnameLength - 1);
    if (lastChar === '/') {
      const url = pathname.slice(0, -1);
      return url;
    }
    return pathname;
  }

  //fixing url not found url no
  if (!isValidUrl) {
    history.push('/');
    return;
  }

  return (
    <Route
      {...rest}
      render={props => {
        if (!isAuthenticated) {
          return loginWithRedirect({});
        }

        return <Component {...props} {...rest} totalSecureRoutes={totalSecureRoutes} />;
      }}
    />
  );
};

SecureRoute.propTypes = {
  component: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
  scopes: PropTypes.array,
};

SecureRoute.defaultProps = {
  scopes: [],
};

export default SecureRoute;
